export const UNAUTHENTICATED_ROUTE_TERMINALS = {
  Login: 'login',
} as const;

export const AUTHENTICATED_ROUTE_TERMINALS = {
  ROOT: 'admin',
  Dealerships: {
    ROOT: 'dealerships',
    Create: 'create',
    Details: {
      ROOT: ':dealershipId',
      Overview: 'overview',
      Members: 'members',
      Policies: 'policies',
      SecurityTests: 'security-tests',
      Documents: 'documents',
      ExecutiveReports: 'executive-reports',
      RiskAssessments: 'risk-assessments',
      VendorOrganizations: 'vendor-organizations',
      VendorRequests: 'vendor-requests',
      VendorResponses: 'vendor-responses',
      AddUsers: 'add-users',
      MailingRecipients: 'mailing-recipients',
      NotificationSettings: 'notification-settings',
      AffiliateGroups: 'affiliate-groups',
      AddAffiliateGroups: 'add-affiliate-groups',
    },
  },
  Documents: {
    ROOT: 'documents',
    Create: 'create',
    Details: {
      ROOT: ':documentId',
      Overview: 'overview',
    },
  },
  ApplicationUsers: {
    ROOT: 'users',
    Create: 'create',
    Details: {
      ROOT: ':userId',
      Overview: 'overview',
      Dealerships: 'dealerships',
      AddDealers: 'add-dealers',
      Actions: 'actions',
    },
  },
  Vendors: {
    ROOT: 'vendors',
    Details: {
      ROOT: ':vendorId',
      Overview: 'overview',
      responses: 'responses',
      requests: 'requests',
      dealerships: 'dealerships',
      dealershipUploads: 'dealership-uploads',
    },
  },
  VendorRequests: {
    ROOT: 'vendor-requests',
    Details: {
      ROOT: ':vendorRequestId',
      Overview: 'overview',
      Response: 'response',
    },
  },
  RiskAssessmentDocuments: {
    ROOT: 'risk-assessments',
    Details: {
      ROOT: ':riskAssessmentId',
      Overview: 'overview',
      Edit: 'edit',
      Risks: 'risks',
      Answers: 'answers',
    },
  },
  VendorRisks: {
    ROOT: 'vendor-risks',
    Details: {
      ROOT: ':vendorRiskId',
      Overview: 'overview',
      Response: 'response',
      Dealerships: 'dealerships',
    },
  },
  Tasks: {
    ROOT: 'tasks',
    Details: {
      ROOT: ':taskId',
      Overview: 'overview',
      Comments: 'comments',
    },
  },
  Risks: {
    ROOT: 'risks',
    Details: {
      ROOT: ':riskId',
      Overview: 'overview',
      Tasks: 'tasks',
    },
  },
  ThirdPartyApi: {
    ROOT: 'third-party-api',
    Tabs: {
      SentinelOne: {
        ROOT: 'sentinel-one',
        OperatingSystems: 'operating-systems',
      },
    },
  },
  AffiliateGroups: {
    ROOT: 'affiliate-groups',
    Create: 'create',
    Details: {
      ROOT: ':affiliateGroupId',
      Overview: 'overview',
      AddDealerships: 'add-dealerships',
      Dealerships: 'dealerships',
    },
  },
  Statistics: {
    ROOT: 'statistics',
    Tabs: {
      UserActions: 'user-actions',
      NavigationEvents: 'navigation-events',
    },
  },
} as const;

export const ROUTES = {
  Root: `/${AUTHENTICATED_ROUTE_TERMINALS.ROOT}/*`,
  Login: `/${UNAUTHENTICATED_ROUTE_TERMINALS.Login}`,
  Dealerships: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.ROOT}/*`,
    Create: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Create}`,
    Dealership: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Overview}`,
      Members: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Members}`,
      Policies: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Policies}`,
      SecurityTests: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.SecurityTests}`,
      Documents: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Documents}`,
      ExecutiveReports: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.ExecutiveReports}`,
      RiskAssessments: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.RiskAssessments}`,
      VendorOrganizations: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorOrganizations}`,
      VendorRequests: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorRequests}`,
      VendorResponses: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorResponses}`,
      AddUsers: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AddUsers}`,
      MailingRecipients: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.MailingRecipients}`,
      NotificationSettings: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.NotificationSettings}`,
      AffiliateGroups: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AffiliateGroups}`,
      AddAffiliateGroups: `/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AddAffiliateGroups}`,
    },
  },
  Documents: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Documents.ROOT}/*`,
    Create: `/${AUTHENTICATED_ROUTE_TERMINALS.Documents.Create}`,
    Document: {
      ROOT: `/${AUTHENTICATED_ROUTE_TERMINALS.Documents.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.Documents.Details.Overview}`,
    },
  },
  ApplicationUsers: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.ROOT}/*`,
    Create: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Create}`,
    User: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Overview}`,
      Dealerships: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Dealerships}`,
      AddDealers: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.AddDealers}`,
      Actions: `/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Actions}`,
    },
  },
  Vendors: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.ROOT}/*`,
    Vendor: {
      ROOT: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.Overview}`,
      Responses: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.responses}`,
      Requests: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.requests}`,
      Dealerships: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.dealerships}`,
      DealershipUploads: `/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.dealershipUploads}`,
    },
  },
  VendorRequests: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.ROOT}/*`,
    VendorRequest: {
      ROOT: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.Details.ROOT}/*`,
      Details: {
        Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.Details.Overview}`,
        Response: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.Details.Response}`,
      },
    },
  },
  RiskAssessmentDocuments: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.ROOT}/*`,
    RiskAssessment: {
      Root: `${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.ROOT}/*`,
      Details: {
        Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Overview}`,
        Edit: `/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Edit}`,
        Risks: `/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Risks}`,
        Answers: `/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Answers}`,
      },
    },
  },
  VendorRisks: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.ROOT}/*`,
    Details: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Overview}`,
      Response: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Response}`,
      Dealerships: `/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Dealerships}`,
    },
  },
  Tasks: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.ROOT}/*`,
    Task: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.Details.Overview}`,
      Comments: `/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.Details.Comments}`,
    },
  },
  Risks: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Risks.ROOT}/*`,
    Risk: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Risks.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.Risks.Details.Overview}`,
      Tasks: `/${AUTHENTICATED_ROUTE_TERMINALS.Risks.Details.Tasks}`,
    },
  },
  ThirdPartyApi: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.ROOT}/*`,
    Tabs: {
      SentinelOne: {
        ROOT: `/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.Tabs.SentinelOne.ROOT}/*`,
        OperatingSystems: `/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.Tabs.SentinelOne.OperatingSystems}`,
      },
    },
  },
  AffiliateGroups: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.ROOT}/*`,
    Create: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Create}`,
    AffiliateGroup: {
      Root: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.ROOT}/*`,
      Overview: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.Overview}`,
      AddDealerships: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.AddDealerships}`,
      Dealerships: `/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.Dealerships}`,
    },
  },
  Statistics: {
    Root: `/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.ROOT}/*`,
    Tabs: {
      UserActions: `/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.Tabs.UserActions}`,
      NavigationEvents: `/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.Tabs.NavigationEvents}`,
    },
  },
} as const;

export const PATHS = {
  ROOT: `/${AUTHENTICATED_ROUTE_TERMINALS.ROOT}`,
  get Login() {
    return `/${UNAUTHENTICATED_ROUTE_TERMINALS.Login}` as const;
  },
  get Dealerships() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.ROOT}`,
      get Dealership() {
        return {
          ROOT: (dealershipId: string) => `${this.ROOT}/${dealershipId}` as const,
          Create: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Create}` as const,
          get Details() {
            return {
              ROOT: (dealershipId: string) => `${this.ROOT(dealershipId)}` as const,
              Overview: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Overview}` as const,
              Members: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Members}` as const,
              Policies: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Policies}` as const,
              SecurityTests: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.SecurityTests
                }` as const,
              Documents: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.Documents}` as const,
              ExecutiveReports: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.ExecutiveReports
                }` as const,
              RiskAssessments: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.RiskAssessments
                }` as const,
              VendorOrganizations: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorOrganizations
                }` as const,
              VendorRequests: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorRequests
                }` as const,
              VendorResponses: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.VendorResponses
                }` as const,
              AddUsers: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AddUsers}` as const,
              MailingRecipients: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.MailingRecipients
                }` as const,
              NotificationSettings: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.NotificationSettings
                }` as const,
              AffiliateGroups: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AffiliateGroups
                }` as const,
              AddAffiliateGroups: (dealershipId: string) =>
                `${this.ROOT(dealershipId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.Dealerships.Details.AddAffiliateGroups
                }` as const,
            };
          },
        };
      },
    } as const;
  },
  get Documents() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Documents.ROOT}`,
      get Document() {
        return {
          ROOT: (documentId: string) => `${this.ROOT}/${documentId}` as const,
          Create: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Documents.Create}` as const,
          get Details() {
            return {
              Overview: (documentId: string) =>
                `${this.ROOT(documentId)}/${AUTHENTICATED_ROUTE_TERMINALS.Documents.Details.Overview}` as const,
            };
          },
        };
      },
    };
  },
  get ApplicationUsers() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.ROOT}` as const,
      get User() {
        return {
          ROOT: (userId: string) => `${this.ROOT}/${userId}` as const,
          Create: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Create}` as const,
          get Details() {
            return {
              Overview: (userId: string) =>
                `${this.ROOT(userId)}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Overview}` as const,
              Dealerships: (userId: string) =>
                `${this.ROOT(userId)}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Dealerships}` as const,
              AddDealers: (userId: string) =>
                `${this.ROOT(userId)}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.AddDealers}` as const,
              Actions: (userId: string) =>
                `${this.ROOT(userId)}/${AUTHENTICATED_ROUTE_TERMINALS.ApplicationUsers.Details.Actions}` as const,
            };
          },
        };
      },
    };
  },
  get Vendors() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.ROOT}` as const,
      get Vendor() {
        return {
          ROOT: (vendorId: string) => `${this.ROOT}/${vendorId}` as const,
          get Details() {
            return {
              ROOT: (vendorId: string) => `${this.ROOT(vendorId)}` as const,
              Overview: (vendorId: string) =>
                `${this.ROOT(vendorId)}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.Overview}` as const,
              Responses: (vendorId: string) =>
                `${this.ROOT(vendorId)}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.responses}` as const,
              Requests: (vendorId: string) =>
                `${this.ROOT(vendorId)}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.requests}` as const,
              Dealerships: (vendorId: string) =>
                `${this.ROOT(vendorId)}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.dealerships}` as const,
              DealershipUploads: (vendorId: string) =>
                `${this.ROOT(vendorId)}/${AUTHENTICATED_ROUTE_TERMINALS.Vendors.Details.dealershipUploads}` as const,
            };
          },
        };
      },
    };
  },
  get VendorRequests() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.ROOT}` as const,
      get VendorRequest() {
        return {
          ROOT: (vendorRequestId: string) => `${this.ROOT}/${vendorRequestId}` as const,
          get Details() {
            return {
              Overview: (vendorRequestId: string) =>
                `${this.ROOT(vendorRequestId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.Details.Overview
                }` as const,
              Response: (vendorRequestId: string) =>
                `${this.ROOT(vendorRequestId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.VendorRequests.Details.Response
                }` as const,
            };
          },
        };
      },
    };
  },
  get RiskAssessmentDocuments() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.ROOT}` as const,
      get RiskAssessment() {
        return {
          ROOT: (RiskAssessmentId: string) => `${this.ROOT}/${RiskAssessmentId}` as const,
          get Details() {
            return {
              Overview: (RiskAssessmentId: string) =>
                `${this.ROOT(RiskAssessmentId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Overview
                }` as const,
              Edit: (RiskAssessmentId: string) =>
                `${this.ROOT(RiskAssessmentId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Edit
                }` as const,
              Risks: (RiskAssessmentId: string) =>
                `${this.ROOT(RiskAssessmentId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Risks
                }` as const,
              Answers: (riskAssessmentId: string) =>
                `${this.ROOT(riskAssessmentId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.RiskAssessmentDocuments.Details.Answers
                }` as const,
            };
          },
        };
      },
    };
  },
  get VendorRisks() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.ROOT}` as const,
      get VendorRisk() {
        return {
          ROOT: (vendorRiskId: string) => `${this.ROOT}/${vendorRiskId}` as const,
          get Details() {
            return {
              Overview: (vendorRiskId: string) =>
                `${this.ROOT(vendorRiskId)}/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Overview}` as const,
              Response: (vendorRiskId: string) =>
                `${this.ROOT(vendorRiskId)}/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Response}` as const,
              Dealerships: (vendorRiskId: string) =>
                `${this.ROOT(vendorRiskId)}/${AUTHENTICATED_ROUTE_TERMINALS.VendorRisks.Details.Dealerships}` as const,
            };
          },
        };
      },
    };
  },
  get Tasks() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.ROOT}` as const,
      get Task() {
        return {
          ROOT: (taskId: string) => `${this.ROOT}/${taskId}` as const,
          get Details() {
            return {
              Overview: (taskId: string) =>
                `${this.ROOT(taskId)}/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.Details.Overview}` as const,
              Comments: (taskId: string) =>
                `${this.ROOT(taskId)}/${AUTHENTICATED_ROUTE_TERMINALS.Tasks.Details.Comments}` as const,
            };
          },
        };
      },
    };
  },
  get Risks() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Risks.ROOT}` as const,
      get Risk() {
        return {
          ROOT: (riskId: string) => `${this.ROOT}/${riskId}` as const,
          get Details() {
            return {
              Overview: (riskId: string) =>
                `${this.ROOT(riskId)}/${AUTHENTICATED_ROUTE_TERMINALS.Risks.Details.Overview}` as const,
              Tasks: (riskId: string) =>
                `${this.ROOT(riskId)}/${AUTHENTICATED_ROUTE_TERMINALS.Risks.Details.Tasks}` as const,
            };
          },
        };
      },
    };
  },
  get ThirdPartyApi() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.ROOT}` as const,
      get Tabs() {
        return {
          SentinelOne: {
            ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.Tabs.SentinelOne.ROOT}` as const,
            get Tabs() {
              return {
                OperatingSystems:
                  `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.ThirdPartyApi.Tabs.SentinelOne.OperatingSystems}` as const,
              };
            },
          },
        };
      },
    };
  },
  get AffiliateGroups() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.ROOT}` as const,
      get AffiliateGroup() {
        return {
          ROOT: (affiliateGroupId: string) => `${this.ROOT}/${affiliateGroupId}` as const,
          Create: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Create}` as const,
          get Details() {
            return {
              ROOT: (affiliateGroupId: string) => `${this.ROOT(affiliateGroupId)}/${affiliateGroupId}` as const,
              Overview: (affiliateGroupId: string) =>
                `${this.ROOT(affiliateGroupId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.Overview
                }` as const,
              AddDealerships: (affiliateGroupId: string) =>
                `${this.ROOT(affiliateGroupId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.AddDealerships
                }` as const,
              Dealerships: (affiliateGroupId: string) =>
                `${this.ROOT(affiliateGroupId)}/${
                  AUTHENTICATED_ROUTE_TERMINALS.AffiliateGroups.Details.Dealerships
                }` as const,
            };
          },
        };
      },
    };
  },
  get Statistics() {
    return {
      ROOT: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.ROOT}` as const,
      get Tabs() {
        return {
          UserActions: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.Tabs.UserActions}` as const,
          NavigationEvents: `${this.ROOT}/${AUTHENTICATED_ROUTE_TERMINALS.Statistics.Tabs.NavigationEvents}` as const,
        };
      },
    };
  },
} as const;

export const DOCUMENTS_HOME_PATH = PATHS.Documents.ROOT;
export const VENDORS_HOME_PATH = PATHS.Vendors.ROOT;
export const DEALERSHIPS_HOME_PATH = PATHS.Dealerships.ROOT;
export const APPLICATION_USERS_HOME_PATH = PATHS.ApplicationUsers.ROOT;
export const RISK_ASSESSMENT_DOCUMENTS_HOME_PATH = PATHS.RiskAssessmentDocuments.ROOT;
export const VENDOR_REQUESTS_HOME_PATH = PATHS.VendorRequests.ROOT;
export const HOME_PATH = PATHS.ROOT;
export const STATISTICS_HOME_PATH = PATHS.Statistics.ROOT;
export const AFFILIATE_GROUPS_HOME_PATH = PATHS.AffiliateGroups.ROOT;
export const VENDOR_RISK_HOME_PATH = PATHS.VendorRisks.ROOT;
